@if (!ghResulted) {
    <div class="gh-distance">
        @if (race.racingpost?.distance) {
            <span> {{ race.racingpost?.distance }}{{ sitecore.horseRacing.raceResulted.Meters }} | </span>
        } @else {
            @if (race.addons.distance) {
                <span> {{ race.addons.distance }} | </span>
            }
        }
    </div>
} @else {
    @if (race.racingpost?.distance) {
        <span class="gh-win-market-resulted"> {{ race.racingpost?.distance }}{{ sitecore.horseRacing.raceResulted.Meters }} </span>
    } @else {
        @if (race.addons.distance) {
            <span class="gh-win-market-resulted"> {{ race.addons.distance }}</span>
        }
    }
}
